module.exports = __webpack_public_path__ + "img/nav-staking.c4052fa.svg";